import { FETCH_NOTIFICATIONS, LOAD_PROJECT, LOGOUT, DESTROY_NOTIFICATION_MESSAGE, REDEEM_COUPON, UPDATE_SUBSCRIPTION } from '../actions/actionTypes.js';
import filter from 'lodash/filter';

const initialState = []
const successMessage = {message: "You're all set!", color: 'success', local:true};

export const notifications = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS.SUCCESS:
      return (action.payload && [...action.payload, ...filter(state, {local:true})]) || initialState
    case DESTROY_NOTIFICATION_MESSAGE.SUCCESS:
      return action.payload.idx >= 0 ? [
        ...state.slice(0, action.payload.idx),
        ...state.slice(action.payload.idx + 1)
      ] : state;
    case LOAD_PROJECT.SUCCESS:
    case LOGOUT:
      const { success_msg } = action.payload
      return success_msg === true ? [...initialState, successMessage] : initialState;
    case REDEEM_COUPON.SUCCESS:
      return [...state, successMessage]
    case UPDATE_SUBSCRIPTION.SUCCESS:
      return [...state, successMessage]
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/notifications.js